<div class="login row">
  <div class="BGLogin col">
    <img src="assets/svg/BG-Login.png"/>
  </div>
  <div class="Login_BoxForm col-3">
    <div class="BoxForm_Content">
      <div class="BoxForm_Title">
        <img src="assets/svg/icon_login.svg">
        <p>Olá, bem-vindo</p>
      </div>
      <div class="BoxForm_Form">
        <div class="choose">
          @if (!isAtendimentoRoute) {
            <div class="label">Escolha uma opção:</div>
            <div style="margin-top:2rem; margin-bottom:2rem;">
              <app-generic-button style="margin-left:1.5rem;"
                                  [description]="'Concluir a criação de acesso'"
                                  [isBtnWithBorder]="true"
                                  [classIconLeft]="'ico-first-access'"
                                  [data-e2e]="'btn-redirect-first-access'"
                                  [id-html]="'btn-redirect-first-access'"
                                  [customWidthSize]="'18rem'"
                                  [buttonColor]="'secundary'"
                                  (emitterEvtClick)="firstAccess()">
              </app-generic-button>
            </div>
            <div>
              <app-generic-button style="margin-left:1.5rem"
                                  [description]="'Já sou cadastrado'"
                                  [isBtnWithBorder]="true"
                                  [classIconLeft]="'ico-login'"
                                  [data-e2e]="'btn-redirect-login'"
                                  [id-html]="'btn-redirect-login'"
                                  [customWidthSize]="'18rem'"
                                  [isDisable]="isLoading"
                                  (emitterEvtClick)="login()">
              </app-generic-button>
            </div>
            @if (isTestEnv) {
              <div>
                <input #inputIdentify type="text" id="input-identify" data-e2e="input-identify" [hidden]="true"/>
              </div>
            }
          }

          @if (isAtendimentoRoute) {
            <div class="btn-login-backoffice">
              <app-generic-button style="margin-left:1.5rem"
                                  [description]="'Login'"
                                  [isBtnWithBorder]="true"
                                  [classIconLeft]="'ico-login'"
                                  [data-e2e]="'btn-redirect-login'"
                                  [id-html]="'btn-redirect-login'"
                                  [customWidthSize]="'18rem'"
                                  [isDisable]="isLoading"
                                  (emitterEvtClick)="login()">
              </app-generic-button>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="edenredMobile"><img src="assets/svg/logo-edenred.svg"/><img src="assets/svg/logo-ticket-log.svg"/>
      </div>
    </div>
  </div>
</div>

